export class ObservableSet extends Set {
  constructor(...args) {
    super(...args);
    this.observers = new Set();
    this.add = value => {
      super.add(value);
      this.notify();
      return this;
    };
    this.delete = value => {
      const result = super.delete(value);
      this.notify();
      return result;
    };
    this.clear = () => {
      super.clear();
      this.notify();
    };
    this.subscribe = observer => {
      this.observers.add(observer);
      return () => this.unsubscribe(observer);
    };
    this.unsubscribe = observer => {
      this.observers.delete(observer);
    };
    this.notify = () => {
      this.observers.forEach(observer => observer(this));
    };
  }
}